export default __webpack_public_path__ + "static/media/userWhite.e30438cb.svg";